import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { globalStyle, style } from '@vanilla-extract/css';

export const streamFollowersBlock = style({
  ...typography.labelSm,

  color: themeVars.container.foreground.secondary,
  display: 'flex',
  alignItems: 'center',
  gap: space.s4,
  transition: '.2s',
  lineHeight: 1,
});

globalStyle(`${streamFollowersBlock} svg`, {
  flexShrink: 0,
});
